import { axiosInstanceMain } from "../../../utils/axiosGlobalUtils";
import { ITenant } from "../../AbmLocalPage/types";
import { Product } from "../types/product";

export const getAllProducts = async (
  tenant: ITenant,
  localId: number,
  ordenamiento: string,
  estado: string,
  page: number,
  pageSize: number,
  searchFilter: string | undefined,
  rubroFilter: number | undefined,
) => {
  const queryParams = [];

  queryParams.push(`page=${page + 1}&pagesize=${pageSize}`);
  if (searchFilter && searchFilter !== "")
    queryParams.push(`search=${searchFilter}`);
  if (rubroFilter && rubroFilter !== 0)
    queryParams.push(`idRubro=${rubroFilter}`);

  const queryString = queryParams.join("&");
  let url = `/${
    tenant.path
  }/productos/local/v2/${localId}?ordenamiento=${ordenamiento}&estado=${estado}${
    queryString ? `&${queryString}` : ""
  }`;

  const data = await axiosInstanceMain.get(url);
  const ofertas = data.data;
  return ofertas;
};

// TODO: apply trycatch
export const deleteProduct = async (productId: number, tenant: ITenant) =>
  await axiosInstanceMain.delete(`/${tenant.path}/productos/${productId}`);
export const deleteProducts = async (productsId: string, tenant: ITenant) =>
  await axiosInstanceMain.delete(`/${tenant.path}/productos?ids=${productsId}`);
export const updateProduct = async (product: any, tenant: ITenant) =>
  await axiosInstanceMain.put(
    `/${tenant.path}/productos/${product.idProducto}`,
    product
  );
export const pauseProduct = async (productId: number, tenant: ITenant) =>
  await axiosInstanceMain.post(`/${tenant.path}/productos/${productId}/pausar`);
export const pauseProducts = async (productsId: string, tenant: ITenant) =>
  await axiosInstanceMain.post(
    `/${tenant.path}/productos/pausar?ids=${productsId}`
  );
export const unPauseProduct = async (productId: number, tenant: ITenant) =>
  await axiosInstanceMain.post(
    `/${tenant.path}/productos/${productId}/despausar`
  );
export const unPauseProducts = async (productsId: string, tenant: ITenant) =>
  await axiosInstanceMain.post(
    `/${tenant.path}/productos/despausar?ids=${productsId}`
  );
export const changeRubroProducts = async (
  productIds: number[],
  idRubro: number,
  tenant: ITenant
) =>
  await axiosInstanceMain.patch(`/admin/${tenant.path}/productos/rubro`, [
    {
      idRubro: idRubro,
      idProductoList: productIds,
    },
  ]);
export const createProduct = async (product: Product, tenant: ITenant) =>
  await axiosInstanceMain.post(`/${tenant.path}/productos`, product);
export const getProduct = async (productId: number, tenant: ITenant) =>
  await axiosInstanceMain.get(
    `/${tenant.path}/productos/v2/${productId}/vendedor`
  );
export const skuEnUso = async (id: any, sku: string, tenant: ITenant) => {
  const response = await axiosInstanceMain.post(
    `/${tenant.path}/productos/sku-en-uso?idLocal=${id}`,
    sku
  );
  return response.data;
};
export const getPalabrasProhibidas = async (tenant: ITenant) =>
  await axiosInstanceMain.get(`/${tenant.path}/productos/palabras-prohibidas`);
